export enum SubscriptionAction {
  REGISTER = 1,
  RENEW = 2,
  CANCEL = 3,
  CONFIG = 4
}

export enum ManagementType {
  CONCURRENT_MEETING = "CONCURRENT_MEETING",
  CONCURRENT_PARTICIPANT_POOL = "CONCURRENT_PARTICIPANT_POOL"
}
